<template>
  <svg 
    version="1.0" 
    xmlns="http://www.w3.org/2000/svg"
    :width="width" :height="height" 
    viewBox="0 0 112.000000 50.000000"
    preserveAspectRatio="xMidYMid meet"
  >
  <g 
    transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
    fill="#000000" 
    stroke="none"
  >
    <path d="M40 469 c0 -22 -5 -32 -20 -36 -11 -3 -20 -14 -20 -24 0 -12 7 -19
      20 -19 18 0 20 -7 20 -86 0 -47 4 -94 10 -104 21 -40 123 -48 113 -9 -3 11
      -14 19 -27 19 -37 0 -46 19 -46 101 l0 78 32 3 c47 4 51 35 6 40 -29 3 -33 7
      -36 36 -3 26 -7 32 -28 32 -20 0 -24 -5 -24 -31z"/>
    <path d="M248 428 l-28 -10 0 -124 0 -124 25 0 25 0 0 104 c0 114 1 116 60
      126 22 3 36 12 38 23 3 14 -4 17 -45 16 -26 0 -60 -5 -75 -11z"/>
    <path d="M427 433 c-11 -3 -16 -10 -13 -20 3 -8 6 -16 6 -19 0 -2 20 -1 44 2
      57 8 86 -8 86 -46 0 -29 -1 -30 -51 -30 -61 0 -83 -10 -98 -48 -15 -35 -2 -76
      30 -92 24 -14 89 -16 137 -6 l32 8 0 98 c0 54 -3 106 -6 115 -14 35 -100 55
      -167 38z m123 -182 c0 -44 -20 -58 -65 -47 -65 16 -43 86 26 86 39 0 39 0 39
      -39z"/>
    <path d="M847 433 c-3 -5 -15 -48 -27 -98 -31 -127 -34 -130 -63 -65 -13 30
      -30 79 -37 108 -12 52 -12 52 -51 52 -32 0 -39 -3 -39 -20 0 -13 7 -20 19 -20
      14 0 21 -10 25 -35 4 -20 25 -71 47 -114 40 -77 40 -80 25 -109 -21 -40 -20
      -44 7 -40 16 2 32 22 59 74 39 74 92 239 84 261 -6 14 -42 18 -49 6z"/>
    <path d="M704 45 c-8 -21 2 -45 19 -45 20 0 40 27 33 45 -7 19 -45 20 -52 0z"/>
    <path d="M994 45 c-4 -9 0 -23 9 -32 21 -21 49 -9 45 19 -4 28 -45 38 -54 13z"/>
  </g>
</svg>
</template>
<script>
export default {
  name: "TraySvg",
  props: ["width", "height"]
}
</script>